import request from '@/utils/request'
/**
 * 
 * @param {*} loginData 
 * @returns 登录的接口
 */
export function login(loginData) {
    return request({
        url: `/index/login/Logintoken`,
        method: 'post',
        data: loginData,
    })
}

/**
 * 
 * @param {电话} phone 
 * @returns 获取验证码的请求
 */
export function registerSms(phone) {
    return request({
        url: `/index/register/sms`,
        method: 'post',
        data: { phone },
        dataType: 'json',
    })
}
/**
 * 
 * @param {用户名} user_name 
 * @param {时间号} phone 
 * @param {密码} password 
 * @param {验证码} code 
 * @param {验证码参数} sign 
 * @returns 注册的请求
 */
export function register(user_name,phone,password,code,sign) {
    let data= {
        user_name,
        phone,
        password,
        code,
        sign,
    }
    return request({
        url: `/index/register/doRegister`,
        method: 'post',
        data,
        dataType: 'json',
    })
}